import {
  IPriceCorrectionLogs,
  IBackingEstimate,
} from '../models/PriceCorrectionLogs';

export const FETCH_PRICE_CORRECTION_LOGS = 'FETCH_PRICE_CORRECTION_LOGS';
export const FETCH_PRICE_CORRECTION_LOGS_SUCCESS =
  'FETCH_PRICE_CORRECTION_LOGS_SUCCESS';
export const FETCH_PRICE_CORRECTION_LOGS_ERROR =
  'FETCH_PRICE_CORRECTION_LOGS_ERROR';

export const FETCH_BACKING_ESTIMATE = 'FETCH_BACKING_ESTIMATE';
export const FETCH_BACKING_ESTIMATE_SUCCESS = 'FETCH_BACKING_ESTIMATE_SUCCESS';
export const FETCH_BACKING_ESTIMATE_ERROR = 'FETCH_BACKING_ESTIMATE_ERROR';

export interface FetchPriceCorrectionLogs {
  type: typeof FETCH_PRICE_CORRECTION_LOGS;
}

export interface FetchPriceCorrectionLogsSuccess {
  type: typeof FETCH_PRICE_CORRECTION_LOGS_SUCCESS;
  payload: IPriceCorrectionLogs;
}

export interface FetchPriceCorrectionLogsError {
  type: typeof FETCH_PRICE_CORRECTION_LOGS_ERROR;
}

export interface FetchBackingEstimate {
  type: typeof FETCH_BACKING_ESTIMATE;
}

export interface FetchBackingEstimateSuccess {
  type: typeof FETCH_BACKING_ESTIMATE_SUCCESS;
  payload: IBackingEstimate;
}
export interface FetchBackingEstimateError {
  type: typeof FETCH_BACKING_ESTIMATE_ERROR;
}

export type PriceCorrectionLogsActionTypes =
  | FetchPriceCorrectionLogs
  | FetchPriceCorrectionLogsSuccess
  | FetchPriceCorrectionLogsError
  | FetchBackingEstimate
  | FetchBackingEstimateSuccess
  | FetchBackingEstimateError;
